import L from "leaflet";

export default () => {

    const doms = document.querySelectorAll('[data-map]');
    if (doms.length) {
        for (const dom of doms) {
            const json = JSON.parse(dom.getAttribute('data-map'));
            const zoom = parseInt(dom.getAttribute('data-zoom'));
            const map = L.map(dom);

            L.tileLayer('https://api.mapbox.com/styles/v1/{id}/tiles/{z}/{x}/{y}?access_token={accessToken}', {
                attribution: '<a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors, Imagery © <a href="https://www.mapbox.com/">Mapbox</a>',
                maxZoom: 18,
                id: 'smokeydev/cl3dlifuy000s15ro8gcm4g07',
                tileSize: 512,
                zoomOffset: -1,
                accessToken: 'pk.eyJ1Ijoic21va2V5ZGV2IiwiYSI6ImNsM2RqOW0yZjAxbDIzcG1rNzhwa2RycW8ifQ.2STK26mUhWl5EK2s8FffWA'
            }).addTo(map);


            const bounds = [];
            for (const pin of json) {
                const latlng = [
                    parseFloat(pin.latitude),
                    parseFloat(pin.longitude)
                ];
                bounds.push(latlng);
                let html = '';
                if (pin.title) {
                    html += `<h3>${pin.title}</h3>`;
                }
                if (pin.phone) {
                    html += `<p><a href="tel:${pin.phone}">T: ${pin.phone}</a></p>`;
                }
                if (pin.email) {
                    html += `<p><a href="mailto:${pin.email}">E: ${pin.email}</a></p>`;
                }
                if (pin.website) {
                    html += `<p><a href="${pin.website}" target="_blank">W: ${pin.website}</a></p>`;
                }
                if (pin.address) {
                    html += `<p>${pin.address}</p>`;
                }

                const marker = L.marker(latlng);
                const popup = L.popup()
                    .setLatLng(latlng)
                    .setContent(html);

                marker.bindPopup(popup).openPopup();
                marker.addTo(map);
            }

            map.fitBounds(bounds);
            if (zoom) {
                map.setZoom(zoom);
            }
        }
    }

}
